// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"7059387e","391":"545959e7"}[chunkId] + ".chunk.css";
};